import { useEffect } from 'react';
import { MapItemTypeData } from '../../data';

declare global {
  interface Window {
    kakao: any;
  }
}

interface MapCoreProps {
  id: string;
  lat: number;
  lng: number;
  geom?: number[][]; // [[lng, lat], [lng, lat], ...]
  groupCategory: string;
  roadView?: boolean;
}

export const MapCore = ({
  id,
  lat,
  lng,
  geom = [],
  groupCategory,
  roadView = false,
}: MapCoreProps) => {
  useEffect(() => {
    const initMap = () => {
      const container = document.getElementById(id);
      if (!container) return;

      // 기존 맵 제거 (초기화)
      container.innerHTML = '';

      const options = {
        center: new window.kakao.maps.LatLng(lat, lng),
        draggable: false,
        level: 3,
        mapTypeId: window.kakao.maps.MapTypeId.SKYVIEW,
      };

      const getMarkerImage = () => {
        const defaultImage = '/assets/images/marker/etc.svg';
        const item = MapItemTypeData.find((data) => data.value === groupCategory);
        return item ? item.markerImg : defaultImage;
      };

      const markerImage = new window.kakao.maps.MarkerImage(
        getMarkerImage(),
        new window.kakao.maps.Size(58, 58)
      );

      if (roadView) {
        const roadview = new window.kakao.maps.Roadview(container, options);
        const roadviewClient = new window.kakao.maps.RoadviewClient();
        const position = new window.kakao.maps.LatLng(lat, lng);

        roadviewClient.getNearestPanoId(position, 100, (panoId: any) => {
          if (panoId) {
            roadview.setPanoId(panoId, position);

            new window.kakao.maps.Marker({
              position,
              map: roadview,
              image: markerImage,
            });
          } else {
            alert('로드뷰가 지원되지 않는 지역입니다.');
          }
        });
      } else {
        const map = new window.kakao.maps.Map(container, options);

        // ✅ map 객체를 container에 임시 저장 (relayout용)
        (container as any).__kakaoMapInstance = map;

        new window.kakao.maps.Marker({
          position: new window.kakao.maps.LatLng(lat, lng),
          map,
          image: markerImage,
        });

        if (geom.length > 0) {
          const polygonPath = geom.map(
            ([lng, lat]) => new window.kakao.maps.LatLng(lat, lng)
          );

          const polygon = new window.kakao.maps.Polygon({
            path: polygonPath,
            strokeWeight: 3,
            strokeColor: '#00B155',
            strokeOpacity: 0.8,
            fillColor: '#00E989',
            fillOpacity: 0.5,
          });

          polygon.setMap(map);
        }
      }
    };

    const tryInitMap = () => {
      if (
        typeof window.kakao !== 'undefined' &&
        typeof window.kakao.maps !== 'undefined'
      ) {
        initMap();
      } else {
        setTimeout(tryInitMap, 300);
      }
    };

    if (
      typeof window !== 'undefined' &&
      typeof lat === 'number' &&
      typeof lng === 'number'
    ) {
      tryInitMap();
    }
  }, [id, lat, lng, geom, groupCategory, roadView]);

  return <div id={id} style={{ width: '100%', height: '100%' }} />;
};